import { FieldValues, useController } from "react-hook-form";

import { DefaultProps, SelectFieldProps } from "../FormField";
import { Option, StyledSelect } from "../Dropdown";

type Props<T extends FieldValues, OptionT = string> = Omit<
  DefaultProps<T> & SelectFieldProps<OptionT>,
  "type"
>;

const SelectField = <T extends FieldValues, OptionT = string>({
  name,
  control,
  disabled,
  options,
  onChangeCallback,
  ...rest
}: Props<T, OptionT>) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <StyledSelect
      $hasError={!!error}
      classNamePrefix="react-select"
      isDisabled={disabled}
      options={options}
      onChange={(option) => {
        field.onChange((option as Option<OptionT>).value);
        onChangeCallback?.();
      }}
      value={options!.find((option) => option.value === field.value) ?? null}
      onBlur={field.onBlur}
      {...rest}
    />
  );
};

export default SelectField;
